import React from 'react';
import {useTranslation, withTranslation} from 'react-i18next';
import {NotificationManager} from 'react-notifications';
import _ from 'lodash';
import {Timeline} from '../../../shared/elements/timeline/Timeline';
import {removeTimeOffset} from '../../../util/date';
import {getTimelineEntries} from './endpoints';
import {timelineEntryComponents} from './entries';
import {AddCustomNote} from './AddCustomNote';

const ALL_CATEGORIES = ['Customers', 'ExtraWorkEntries', 'Uploads', 'Downloads', 'Notes'];

const WarehousingTimeline = () => {
    const {t} = useTranslation();
    const [timeline, setTimeline] = React.useState({loading: true, entries: []});
    const [visibleCategories, setVisibleCategories] = React.useState(
        _.reduce(ALL_CATEGORIES, (all, category) => ({...all, [category]: true}), {}),
    );

    const visibleEntries = timeline.entries.filter((entry) => visibleCategories[entry.category]);

    const toggleCategoryVisibility = (category) =>
        setVisibleCategories((state) => ({...state, [category]: !state[category]}));

    const loadTimelineEntries = () => {
        getTimelineEntries()
            .then((response) =>
                _(response.data)
                    .map((entry) => ({
                        ...entry,
                        createdAt: new Date(removeTimeOffset(entry.createdAt)),
                        fromDate: entry.fromDate ? new Date(removeTimeOffset(entry.fromDate)) : undefined,
                        toDate: entry.toDate ? new Date(removeTimeOffset(entry.toDate)) : undefined,
                        timestamp: entry.timestamp ? new Date(removeTimeOffset(entry.timestamp)) : undefined,
                    }))
                    // Sort newest to oldest
                    .orderBy(['createdAt'], ['desc'])
                    .value(),
            )
            .then((data) => {
                setTimeline((state) => ({...state, entries: data}));
            })
            .catch(() => {
                NotificationManager.error(t('warehousing.timeline.error'));
            })
            .finally(() => {
                setTimeline((state) => ({...state, loading: false}));
            });
    };

    React.useEffect(() => {
        loadTimelineEntries();
    }, []);

    return (
        <div>
            <h2>{t('warehousing.timeline.title')}</h2>

            {ALL_CATEGORIES.map((category) => (
                <label key={category} style={{display: 'block'}}>
                    <input
                        type="checkbox"
                        checked={visibleCategories[category]}
                        onChange={() => toggleCategoryVisibility(category)}
                    />
                    {t(`warehousing.timeline.categories.${category}`)}
                </label>
            ))}

            <AddCustomNote onNoteCreate={loadTimelineEntries} />

            <Timeline>
                <div>
                    {!timeline.loading &&
                        visibleEntries.map((entry) => {
                            const Component = timelineEntryComponents[entry.type];
                            return Component ? <Component entry={entry} /> : null;
                        })}
                </div>
            </Timeline>
        </div>
    );
};

export default withTranslation()(WarehousingTimeline);
